"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckboxWrapper = exports.StyledProductPageLink = exports.StyledOptionsIcon = exports.StyledExternalLinkIcon = exports.StyledProductDetailsIconButton = exports.StyledProductLinksContainer = exports.StyledImageWrapper = exports.StyledTitleWrapper = exports.StyledSkuWrapper = exports.StyledProductTileWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledProductTileWrapper = styled_components_1.default.div `
  border-radius: 8px; 
  border: 2px solid  ${({ selected }) => (selected ? ui_components_1.baseColors.primaryGreen300 : ui_components_1.baseColors.primaryGray200)};
  padding: 12px 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 200px;
  font-size: 10px;
  position: relative;
  cursor: pointer;
`;
exports.StyledSkuWrapper = styled_components_1.default.div `
  line-height: 1rem;
  font-size: 10px;
  text-align: right;
  font-family: Roboto;
  margin-top: 8px;
  color: ${({ theme }) => theme.palette.grey[600]};
  width: 100%;
`;
exports.StyledTitleWrapper = styled_components_1.default.div `
  color: ${({ theme }) => theme.palette.accent.main};;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5rem;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
`;
exports.StyledImageWrapper = styled_components_1.default.div `
  border-radius: 8px;
  border: 1px solid  ${ui_components_1.baseColors.border};
  height: 145px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  &.no-border-bottom-radius {
    border-bottom-right-radius:0;
    border-bottom-left-radius:0;
  }

  .badge-wrapper {
    position: absolute;
    top:0;
    left:0;
  }
`;
exports.StyledProductLinksContainer = styled_components_1.default.div `
  height: 2rem;
  width: 100%;
  display: flex;
  margin-top: 0.5rem;
  font-size: 12px;
  gap: 5px;
`;
exports.StyledProductDetailsIconButton = (0, styled_components_1.default)(material_1.IconButton) `
  border-radius: 0.25rem;
  border: 1px solid ${ui_components_1.baseColors.primaryGray200};
  width: 32px;
`;
exports.StyledExternalLinkIcon = (0, styled_components_1.default)(ui_components_1.Icon) `
  transform: scale(0.65);
  &.icon-wrapper-class {
    svg > path {
        fill: ${ui_components_1.baseColors.primaryBlueDark500};
      }
    }
  `;
exports.StyledOptionsIcon = (0, styled_components_1.default)(MoreVert_1.default) `
  transform: scale(0.65);
  &.icon-wrapper-class {
    svg > path {
        fill: ${ui_components_1.baseColors.primaryBlueDark500};
      }
    }
  `;
exports.StyledProductPageLink = (0, styled_components_1.default)(material_1.Link) `
  margin-right: auto;
  border-radius: 0.25rem;
  border: 1px solid ${ui_components_1.baseColors.primaryGray200};
  padding: 0.5rem;
  padding-right: 5px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  color: ${ui_components_1.baseColors.primaryBlueDark500};
  box-sizing: border-box;
  flex: 1;
  pointer-events: ${({ disabled }) => disabled && 'none'};
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledCheckboxWrapper = styled_components_1.default.div `
    position: absolute;
    right: ${({ theme }) => theme.spacing(1)};
    top: ${({ theme }) => theme.spacing(1)};
    z-index: 1;

    svg {
      width: 0.75em 
    }
`;
